import { useQueryClient } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { Suspense, useCallback, useEffect, useState } from 'react'

import { mapQueries, type TMarkerSearchParams } from '@/entities/map'
import { SearchMap } from '@/features/search-map'
import { BridgeProvider } from '@/shared/lib'
import { Language, ZLanguage } from '@/shared/model'

import { RoomList } from './room-list'
import Sidebar from './sidebar'

export const RoomFinder = () => {
  const locale = useLocale()

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const queryClient = useQueryClient()

  const language = (() => {
    const parsedLanguage = ZLanguage.safeParse(locale)

    if (!parsedLanguage.success) {
      return Language.KO
    }

    return parsedLanguage.data
  })()

  const getMarkers = useCallback(
    async (params: TMarkerSearchParams) => {
      const markers = await queryClient.fetchQuery({
        ...mapQueries.markerList(params),
      })

      return markers
    },
    [queryClient],
  )

  return (
    <div className="flex h-[calc(100vh-72px)] pt-[50px]">
      <Suspense>
        <Sidebar>
          <RoomList isMounted={isMounted} />
        </Sidebar>
      </Suspense>
      <BridgeProvider>
        <div className="relative h-full w-full flex-1 overflow-hidden">
          <SearchMap language={language} getMarkers={getMarkers} />
        </div>
      </BridgeProvider>
    </div>
  )
}
